import { useCheckRole } from '@ospace/auth'
import { userTypes } from '@ospace/core-auth'
import { PageTitle } from '@ospace/layout'
import { ErrorBoundary } from '@ospace/shared'
import { Loader, Paper } from '@mantine/core'

import { UsersTable } from '../components/Users'
import { useUsers } from '../hooks/useUsers'

export const UserPage = () => {
  const { status, data: users, error, isFetching } = useUsers()

  return (
    <Paper p='md' radius='md' m='xl'>
      {isFetching ? (
        <div
          className='d-flex align-items-center justify-content-center'
          style={{ minHeight: '60vh' }}
        >
          <Loader color='blue' />
        </div>
      ) : status === 'error' ? (
        <span>Error: {(error as any).message}</span>
      ) : users ? (
        <UsersTable users={users} />
      ) : (
        <span>No users</span>
      )}
    </Paper>
  )
}

const Controller = () => {
  useCheckRole([userTypes.Admin])
  return <UserPage />
}

export const UserPageRouteHandler = () => (
  <ErrorBoundary>
    <Controller />
  </ErrorBoundary>
)
